export default __webpack_public_path__ + "static/media/template5.3e702af6.png";